import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FeatureManagementService } from '../services/feature-management.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[obscure]',
  standalone: false,
})
export class ObscurityDirective implements OnInit, OnDestroy {
  private featureSubscription: Subscription = new Subscription();
  @Input() enableObscurity = true;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    private readonly featureManagementService: FeatureManagementService,
  ) {}

  ngOnInit(): void {
    if (this.enableObscurity) {
      this.featureSubscription = this.featureManagementService.features.subscribe((features) => {
        const element = this.el.nativeElement as HTMLElement;

        if (features.informationObscurity) {
          this.renderer.addClass(element, 'obscured-text');
        } else {
          this.renderer.removeClass(element, 'obscured-text');
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.featureSubscription.unsubscribe();
  }
}
